import { render, staticRenderFns } from "./ActivitiesCalendar.vue?vue&type=template&id=097e38ed&"
import script from "./ActivitiesCalendar.vue?vue&type=script&lang=js&"
export * from "./ActivitiesCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesCalendar.vue?vue&type=style&index=0&id=097e38ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports